<template>
    <div id="app">
        <main-header></main-header>
        <div
            v-infinite-scroll="handleInfiniteOnLoad"
            class="infinite-container card"
            :infinite-scroll-disabled="end"
            :infinite-scroll-distance="20"
        >
            <a-list :data-source="data">
                <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta :title="formatDate(item.timestamp)">
                        <notifcation-card slot="description" :item="item"></notifcation-card>
                    </a-list-item-meta>
                </a-list-item>
                <div v-if="loading && !end" class="demo-loading-container">
                    <a-spin />
                </div>
            </a-list>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll';
import MainHeader from '@/components/MainHeader.vue';
import Footer from '@/components/Footer.vue';
import axios from 'axios';
import NotifcationCard from './NotifcationCard.vue';

export default {
    directives: { infiniteScroll },
    data: () => ({
        data: [],
        loading: false,
        end: false,
        last: (Date.now() / 1000) | 1,
    }),
    computed: {

    },
    async created() {
        const res = await this.fetchData();
        this.data = res.notifications;
    },
    methods: {
        async fetchData() {
            const { data } = await axios.get("/backend/user/notification.php", {
                params: {
                    timestamp: this.last
                }
            });
            if (data.notifications.length == 0) this.end = true;
            else {
                this.last = data.notifications[data.notifications.length-1].timestamp
            }
            return data;
        },
        async handleInfiniteOnLoad() {
            if (this.end || this.loading) return;
            this.loading = true;
            const res = await this.fetchData();
            this.data.push(...res.notifications);
            this.loading = false;
        },
        formatDate(timestamp) {
            return (new Date(timestamp * 1000)).toLocaleString("cn-ZH", { hour12: false });
        },
    },
    components: {
        MainHeader, Footer,
        NotifcationCard,
    },
};
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
body {
    background-color: #e6e6e6 !important;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.card {
    background-color: #f6f6f6;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(18,18,18,.1);
    box-shadow: 0 1px 3px rgba(18,18,18,.1);
    margin: 6px;
}
.infinite-container {
    position: absolute;
    top: 60px;
    bottom: 70px;
    left: 0;
    right: 0;
    margin: auto;
    padding: 10px;
    width: 100%;
    max-width: 800px;
    text-align: left;
    overflow: auto;
}
</style>
